export const STUDENTS_ROUTES = {
	students: "/app/students",
	detailPattern: "/app/students/:id",
	detail: (id: string) => `/app/students/${id}` as const,
} as const;
